module.exports = __webpack_public_path__ + "img/Arrow-Right-icon.c7c46c04.png";